// This file is generated.
export var version = '1.81.1';
//# sourceMappingURL=version.js.map